import React, { FC } from 'react';
import { create } from 'zustand';
import _ from 'lodash';

export interface QuizOrderStore {
  array: any[];
  setArray: (newArray?: any[]) => void;
  moveUp: (index: number) => void;
  moveDown: (index: number) => void;
  handleCheckAnswers: (
    playWrongAnswerAudioEffect: () => void,
    playRightAnswerAudioEffect: () => void
  ) => void;
  popupWasOpened: boolean;
  setPopupWasOpened: (state: boolean) => void;
}

const _useQuizOrderStore = create<QuizOrderStore>((set, get) => ({
  array: [],
  setArray: newArray => set({ array: newArray }),
  moveUp: index => {
    const ARRAY = get().array;
    if (ARRAY[index].props.state === 'correct') return;

    const nextIndex = (() => {
      for (let i = index - 1; i >= 0; i--) {
        if (
          ARRAY[i].props.state === 'default' ||
          ARRAY[i].props.state === 'wrong'
        ) {
          return i;
        }
      }
    })();

    if (nextIndex || nextIndex === 0) {
      [ARRAY[index], ARRAY[nextIndex]] = [ARRAY[nextIndex], ARRAY[index]];
    }

    set({ array: ARRAY });
  },
  moveDown: index => {
    const ARRAY = get().array;
    if (ARRAY[index].props.state === 'correct') return;

    const nextIndex = (() => {
      for (let i = index + 1; i < ARRAY.length; i++) {
        if (
          ARRAY[i].props.state === 'default' ||
          ARRAY[i].props.state === 'wrong'
        ) {
          return i;
        }
      }
    })();

    if (nextIndex) {
      [ARRAY[index], ARRAY[nextIndex]] = [ARRAY[nextIndex], ARRAY[index]];
    }
    set({ array: ARRAY });
  },
  handleCheckAnswers: (
    playWrongAnswerAudioEffect,
    playRightAnswerAudioEffect
  ) => {
    const ARRAY = get().array;
    let isAnswerCorrect = true;
    set({
      array: ARRAY.map((item, idx) => {
        const tempItem = _.cloneDeep(item);
        if (item.props.initialIndex === idx) {
          tempItem.props.state = 'correct';
          return tempItem;
        } else {
          tempItem.props.state = 'wrong';
          isAnswerCorrect = false;
          return tempItem;
        }
      })
    });
    isAnswerCorrect
      ? playRightAnswerAudioEffect()
      : playWrongAnswerAudioEffect();
  },
  popupWasOpened: false,
  setPopupWasOpened: state => set({ popupWasOpened: state })
}));

export const QuizOrderProvider: FC = ({ children }) => {
  return <>{children}</>
};

export const useQuizOrderStore = _useQuizOrderStore;
